export default {
  title: 'Actions rapides',
  send_push_notification: {
    label: 'Envoyer une notification push',
    description: 'Créer une nouvelle campagne',
  },
  email_campaign: {
    label: 'Campagne e-mail',
    description: 'Envoyer aux abonnés',
  },
  view_analytics: {
    label: 'Voir les statistiques',
    description: 'Performance de la campagne',
  },
};
